import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Target,
  Users,
  PersonStanding,
  Signature,
  Laptop,
  Vault,
  TreePalm,
  Mails,
  Search,
  LogOut,
  User,
} from "lucide-react";

const Header = ({ user, onLogout, searchTerm, onSearchChange }) => {
  const location = useLocation();
  const currentPage = location.pathname;
  let icon = null;
  let pageName;
  let placeholder = "Search ";
  let actionName = "Add ";
  let actionPath = "/";

  switch (currentPage) {
    case "/leads": {
      icon = Target;
      pageName = "Leads";
      placeholder = placeholder + "leads";
      actionName = actionName + "lead";
      actionPath = actionPath + "create_lead";
      break;
    }
    case "/clients": {
      icon = Users;
      pageName = "Clients";
      placeholder = placeholder + "clients";
      actionName = actionName + "client";
      actionPath = actionPath + "create_client";
      break;
    }
    case "/human_resources": {
      icon = PersonStanding;
      pageName = "Human Resources";
      break;
    }
    case "/contracts": {
      icon = Signature;
      pageName = "Contracts";
      break;
    }
    case "/equipment": {
      icon = Laptop;
      pageName = "Equipment";
      break;
    }
    case "/reimbursements": {
      icon = Vault;
      pageName = "Reimbursements";
      break;
    }
    case "/vacations": {
      icon = TreePalm;
      pageName = "Vacations";
      break;
    }
    case "/mail_log": {
      icon = Mails;
      pageName = "Mail Logs";
      placeholder = placeholder + "logs";
      break;
    }
    default: {
      pageName = "";
      break;
    }
  }

  const PageIcon = icon;

  return (
    <div className="canopy-header">
      <div className="flex items-center justify-between">
        {/* Page Title and Add Button */}
        <div className="flex items-center justify-between w-full">
          <div className="inline-flex items-center gap-2">
            {PageIcon ? (
              <span className="w-10 h-10 inline-flex items-center justify-center overflow-visible">
                <PageIcon
                  className="w-6 h-6 scale-150 origin-center"
                  strokeWidth={2.5}
                />
              </span>
            ) : (
              <Link to="/">
                <img
                  className="canopy-page-title-logo"
                  src="/Logo.png"
                  alt="Greenlight Financial"
                  style={{ cursor: "pointer" }}
                />
              </Link>
            )}

            {/* Only show text title if you actually have one */}
            {pageName && (
              <h1 className="text-3xl font-bold text-gray-900">{pageName}</h1>
            )}
          </div>

          <div className="flex items-center space-x-4">
            {/* Search */}
            {(currentPage === "/leads" ||
              currentPage === "/clients" ||
              currentPage === "/mail_log") && (
              <div className="flex items-center space-x-4">
                <div className="flex items-center border border-gray-300 rounded-lg w-80 px-3 py-2">
                  <Search className="h-4 w-4 text-canopy-textMuted mr-2" />
                  <input
                    type="text"
                    placeholder={placeholder}
                    value={searchTerm}
                    onChange={(e) => onSearchChange(e.target.value)}
                    className="flex-1 outline-none"
                  />
                  {searchTerm && (
                    <button
                      onClick={() => onSearchChange("")}
                      className="ml-2 text-gray-400 hover:text-gray-600 focus:outline-none"
                    >
                      ✕
                    </button>
                  )}
                </div>
              </div>
            )}
            {/* Add Button */}
            {(currentPage === "/leads" || currentPage === "/clients") && (
              <Link
                to={actionPath}
                className="canopy-btn-primary flex items-center"
              >
                {actionName}
              </Link>
            )}

            {/* User Menu */}
            <div className="flex items-center space-x-3">
              <div className="flex items-center space-x-2 text-sm text-canopy-textMuted">
                <User className="h-4 w-4" />
                <span className="hidden sm:inline">{user?.name || "User"}</span>
              </div>

              <button
                onClick={onLogout}
                className="p-2 text-canopy-textMuted hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                title="Sign out"
              >
                <LogOut className="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
